import type { SessionContext } from './types';

/**
 * Capability floor shared by the modules that are universal to every active
 * office membership. Tenant isolation and record-state rules remain separate
 * concerns enforced by handlers and repositories.
 */
export const isUniversalModuleUser = (ctx: SessionContext): boolean => ctx.role.ativo;
